import { render } from "./HEWReports.vue?vue&type=template&id=b8f11aca&scoped=true"
import script from "./HEWReports.vue?vue&type=script&lang=js"
export * from "./HEWReports.vue?vue&type=script&lang=js"

import "./HEWReports.vue?vue&type=style&index=0&id=b8f11aca&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/CBHI/PONA HEALTH/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8f11aca"]])

export default __exports__